// extracted by mini-css-extract-plugin
export default {"container":"TF-z","disabled":"UF-z","bgBlack":"VF-z","content":"WF-z","countdown":"XF-z","topCaption":"YF-z","topHeading":"ZF-z","heading":"_F-z","copy":"aG-z"};